__turbopack_context__.v({
  "body": "IVpIpa_body",
  "mediaObject": "IVpIpa_mediaObject",
  "stackInDesktop": "IVpIpa_stackInDesktop",
  "stackInMobile": "IVpIpa_stackInMobile",
});
